export enum SignupMode {
    EMAIL_SIGNUP = 'email/',
    SSO_SIGNUP = 'sso/',
    UNSELECTED = ''
}
export const SizeNarrow = '354px';
export const SizeWide = '426px';
